export const darkMode = 'dark'
export const lightMode = 'light'
